import React, {ReactNode} from 'react';
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {DefaultRegistration} from './DefaultRegistration';
import I18n from 'app/i18n';
import {configStore} from 'app/store/global';
import {observer} from 'mobx-react';

@observer
class FastRegistration extends DefaultRegistration {
    static LEAD_FIELDS = [
        'name',
        'password',
        'email'
    ];

    static METHOD = 'fast';

    render(): ReactNode {
        return this.state.success
            ? <div>{this.state.success}</div>
            : <form id="fast-sign-up" onSubmit={this.signUp} ref={this.rootForm}
                className="form-popup popup-form--error">
                <span className="form-title">{I18n.t('register')}</span>
                <input
                    name="site_lang"
                    type="hidden"
                    value={configStore.CONFIG?.lang}
                />
                <input name="full_registered" type="hidden" value="0"/>
                {[
                    this.rowName(),
                    this.rowEmail(),
                    this.rowPassword(true),
                    this.rowCountryCode(),
                    this.rowNoMarketingConsent(),
                    this.rowTermsOfUse(),
                    this.rowCaptcha()
                ]}
                <div className="popup-form__submit-row">
                    {this.renderRegisterButton(I18n.t('chek_up'))}
                </div>
            </form>;
    }
}

export default withGoogleReCaptcha(FastRegistration);
